import { Directive, ElementRef, OnDestroy } from '@angular/core';

declare var vanillaTextMask: any;

@Directive({
  selector: '[appMaskDate]',
})
export class MaskDateDirective implements OnDestroy {
  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // dd/mm/yyyy
  maskedInputController;

  constructor(private element: ElementRef) {
    this.maskedInputController = vanillaTextMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask,
    });
  }

  ngOnDestroy(): void {
    this.maskedInputController.destroy();
  }
}
